import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { customerTypeSelectorStyles as styles } from "styles/Checkout/customerTypeSelector.styles";
import { ReactComponent as CustomDropDownIcon } from "../../../assets/icons/black_down_arrow.svg";

interface Rate {
  pk: number;
  capacity: number;
  customer_type: {
    singular: string;
  };
  customer_prototype: {
    total: number;
  };
}

interface CustomerTypeSelectorProps {
  rates: Rate[];
  selectedRate: number;
  quantities: { [key: number]: number };
  handleRateChange: (rate: Rate, quantity: number) => void;
  setQuantities: React.Dispatch<
    React.SetStateAction<{ [key: number]: number }>
  >;
}

function CustomerTypeSelector({
  rates,
  selectedRate,
  quantities,
  handleRateChange,
  setQuantities,
}: CustomerTypeSelectorProps) {
  return (
    <>
      {rates?.map((rate) => (
        <Button
          key={rate.pk}
          color={rate.pk === selectedRate ? "success" : "primary"}
          sx={styles.button}
          onClick={() => {
            if (rate?.capacity === 1) {
              handleRateChange(rate, 1);
            }
          }}
        >
          <Box sx={styles.rateContainer(rate.pk === selectedRate)}>
            <Box sx={styles.rowContainer}>
              <Box sx={styles.leftSection(rate.pk === selectedRate, rate?.capacity)}>
                <Box sx={styles.leftSectionContent}>
                  <Box sx={styles.leftSectionTextContainer}>
                    <Typography sx={styles.customerTypeTitle}>
                      {rate?.customer_type?.singular}
                    </Typography>

                    {rate?.capacity > 0 && (
                      <Typography sx={styles.availabilityText}>
                        {rate?.capacity} Available
                      </Typography>
                    )}
                  </Box>
                  {rate.customer_prototype.total > 0 && (
                    <>
                      <Typography sx={styles.priceText}>
                        {"$"}
                        {rate.customer_prototype.total / 100}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>

              {rate.capacity > 1 && (
                <Box sx={styles.rightSection}>
                  <Select
                    value={quantities[rate.pk] ?? ""}
                    onChange={(event) => {
                      const newQty = Number(event.target.value);
                      setQuantities((prevQuantities) => ({
                        ...prevQuantities,
                        [rate.pk]: newQty,
                      }));
                      handleRateChange(rate, newQty);
                    }}
                    displayEmpty
                    IconComponent={CustomDropDownIcon}
                    renderValue={(selected) => selected || 1}
                    sx={styles.selectStyle}
                  >
                    {Array.from(
                      { length: rate?.capacity },
                      (_, idx) => idx + 1
                    ).map((capacity) => (
                      <MenuItem key={capacity} value={capacity}>
                        {capacity}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              )}
            </Box>
          </Box>
        </Button>
      ))}
    </>
  );
}

export default CustomerTypeSelector;
